export default __webpack_public_path__ + "media/Jira_tablet.eff15a14feb10a562509a084d45f2e46.svg";